import { Action, State, StateContext, Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { Login, Logout } from 'src/modules/security/actions/auth-actions';
import { NavigateToPatients } from 'src/app/states/navigations.actions';
import { PostMessageReceived } from 'src/app/states/post-message/post-message.actions';
import { MessageService } from '@bioreferencehealth/ui-kit';

@State({
  name: 'postMessage'
})
@Injectable({
  providedIn: 'root'
})
export class PostMessageState {
  private readonly store: Store = inject(Store);
  private readonly messageService: MessageService = inject(MessageService);

  @Action(PostMessageReceived)
  public postMessageFetched(ctx: StateContext<unknown>, { payload }: PostMessageReceived): void {
    if (payload.status === 200) {
      if (payload.token) {
        this.store.dispatch([new Login(payload.token), new NavigateToPatients()]);
      } else {
        this.store.dispatch(new NavigateToPatients());
      }
    } else if (payload.status === 401 || payload.status === 403) {
      this.messageService.error('Something went wrong. Please try again. If the problem persists, contact support.');
      this.store.dispatch(new Logout());
    }
  }
}
